export interface ISignatureModel {
  imageData?: ImageData,
  data: string,
  xMin: number,
  xMax: number,
  yMin: number,
  yMax: number,
  page: number,
}

export interface IRequestModel {
  'txtOwnerNationality': string
  'txtValuta1': string
  'txtValuta2': string
  'txtValuta3': string
  'txtIznos1': string
  'txtIznos2': string
  'txtIznos3': string
  'txtFormLanguage': string
  'txtDatumRodjenja': string
  'txtData': string
  'txtOwnerBirthDate': string
  'captcha-answer': string
  'captcha-token'?: string
  'txtDan'?: string
  'txtMjesec'?: string
  'txtGodina'?: string
  'txtHrMirovina'?: string
  'txtInoMirovina'?: string
  'txtIme'?: string
  'txtOIB'?: string
  'txtIBAN'?: string
  'txtMobitel'?: string
  'txtEmail'?: string
  'txtPrezime'?: string
  'chkOdgovornost'?: boolean
  'txtDrzava1'?: string
  'txtDrzava2'?: string
  'txtDrzava3'?: string
  'txtDrzavaKod1'?: string
  'txtDrzavaKod2'?: string
  'txtDrzavaKod3'?: string
}

export type FormModel =
  & Omit<IRequestModel, 'txtDatumRodjenja' | 'txtData' | 'txtOwnerBirthDate' | 'txtDan' | 'txtMjesec' | 'txtGodina'>
  & { 'txtDatumRodjenja': Date | null }
  & { 'txtData': Date | null }
  & { 'txtOwnerBirthDate': Date | null }
  & { 'txtDan' : string | null }
  & { 'txtMjesec' : string | null}
  & { 'txtGodina' : string | null }
  & { attachments: File[], }

export const DEFAULT_REQUEST_MODEL: FormModel = {
  'txtOwnerNationality': '',
  'txtFormLanguage':'',
  'txtValuta1':'',
  'txtValuta2':'',
  'txtValuta3':'',
  'txtIznos1':'',
  'txtIznos2':'',
  'txtIznos3':'',
  'txtDatumRodjenja':null,
  'txtData':null,
  'txtOwnerBirthDate':null,
  'captcha-answer':'',
  'txtHrMirovina':'',
  'txtInoMirovina': '',
  'txtDan': '',
  'txtGodina': '',
  'txtMjesec': '',
  'chkOdgovornost': false,
  attachments: [],
}
